import classnames from 'classnames';
import React from 'react';

import css from '../defaultIconStyles.css';

export default function IconGpu({
    width = 20,
    height = 20,
    className,
    ...rest
}) {
    return (
        <svg
            fillRule="evenodd"
            viewBox="0 0 20 20"
            width={width}
            height={height}
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(css.main, className)}
            {...rest}
        >
            <title>Icon gpu</title>
            <path
                d="M16.9952 2C17.5498 2 18 2.43693 18 2.97513V4.90545C18 5.44365 17.5498 5.88057 16.9952 5.88057C16.4407 5.88057 15.9904 5.44365 15.9904 4.90545V3.95025H9.55442L13.2957 9.48222C13.4089 9.64963 13.4621 9.83858 13.4604 10.025C13.4621 10.2114 13.4089 10.4003 13.2957 10.5677L9.58817 16.0497H15.9904V15.0946C15.9904 14.5564 16.4407 14.1194 16.9952 14.1194C17.5498 14.1194 18 14.5564 18 15.0946V17.0249C18 17.5631 17.5498 18 16.9952 18H3.00478C2.45022 18 2 17.5631 2 17.0249C2 16.7445 2.12216 16.4916 2.31764 16.3136L6.57074 10.025L2.16475 3.51019C2.05322 3.34536 2 3.15968 2 2.9761V2.97513V2.97478C2.00007 2.81852 2.03806 2.67076 2.10564 2.53973C2.1822 2.3903 2.29933 2.25795 2.45338 2.15981C2.62329 2.05165 2.81468 1.99993 3.00392 2H3.00478H16.9952ZM4.8662 3.95026L8.60747 9.48222C8.72072 9.64964 8.77387 9.83858 8.77214 10.025C8.77387 10.2114 8.72072 10.4003 8.60747 10.5677L4.89996 16.0497H7.18443L11.259 10.025L7.15068 3.95026H4.8662Z"
                className={css.colored}
            />
        </svg>
    );
}
